import { useQuery, useQueries } from '@tanstack/react-query';
import { getOrganizationOverview, getOrganizationHistoryPoint, overviewMonths, retryOverview } from '../services/overview';

export const overviewScope = (actor) => [actor.user.uuid, actor.role.uuid, actor.role.account.uuid];
export default function useOrganizationOverview(actor) {
    return useQuery({
        queryKey: ['clinic-overview', ...overviewScope(actor), 'summary'],
        queryFn: ({ signal }) => getOrganizationOverview(actor, { signal }),
        staleTime: 30000, refetchOnWindowFocus: false, retry: retryOverview
    });
}
export function useOrganizationHistory(actor, kind, enabled) {
    const queries = useQueries({ queries: overviewMonths().map((month) => ({
        queryKey: ['clinic-overview', ...overviewScope(actor), 'history', kind, month],
        queryFn: ({ signal }) => getOrganizationHistoryPoint(actor, { month, kind, signal }),
        enabled, staleTime: 5 * 60000, refetchOnWindowFocus: false, retry: retryOverview
    })) });
    return {
        data: queries.map((query) => query.data),
        isPending: queries.some((query) => query.isPending),
        isError: queries.some((query) => query.isError),
        error: queries.find((query) => query.isError)?.error,
        isFetching: queries.some((query) => query.isFetching),
        refetch: () => Promise.all(queries.filter((query) => query.isError).map((query) => query.refetch()))
    };
}
